import React from 'react';
import Icon from '../../components/icons';
import Button from '../../components/elements/button';
import Layout from '../../components/layout';
import Header from '../../components/header';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUserSelector } from '../../store/selectors/userSelector';
import { getPermissionInfo } from '../../_common/functions';
import { URLS } from '../../_config';

interface ReportButton {
    label: string;
    path: string;
    isNew?: boolean;
}

const NewBadge: React.FC = () => (
    <span className="inline-flex items-center text-white font-semibold leading-none" style={{ background: '#22c55e', fontSize: 10, borderRadius: 4, padding: '2px 6px', marginLeft: 8, fontWeight: 600 }}>
        New
    </span>
);

const Reports: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const loggedinuser: any = useUserSelector();

    const reportButtons: ReportButton[] = [
        { label: 'Asset Data Report', path: 'report-assets' },
        { label: 'Depreciation Data Report', path: 'report-depreciation' },
        { label: 'Assets Uptime', path: 'assets-uptime', isNew: true },
        { label: 'Assets Time and Cost', path: 'assets-time-cost', isNew: true },
        { label: 'Total and MTTR', path: 'total-mttr', isNew: true },
        { label: 'MTBF', path: 'mtbf', isNew: true },
        { label: 'Warranties Report', path: 'warranties', isNew: true },
        { label: 'Fixed Asset Auditor Report', path: 'auditor', isNew: true },
    ];

    const InventoryReportButtons: ReportButton[] = [
        { label: 'Stock Transaction Data Report', path: 'report-stock-transaction' },
        { label: 'Stock Inventory Balance Report', path: 'report-stock-inventory-balance' },
        { label: 'Low Stock Report', path: 'low-stock', isNew: true },
        { label: 'Spare Parts Usage Report', path: 'spare-parts-usage', isNew: true },
        { label: 'Stock Adjustment Report', path: 'stock-adjustment', isNew: true },
        { label: 'Parts & Preferred Vendor Report', path: 'parts-vendor-report', isNew: true },
    ];

    const taskReportButtons: ReportButton[] = [
        { label: 'Closed Tasks Detail Report', path: 'closed-tasks', isNew: true },
    ];

    const renderButton = (btn: ReportButton, idx: number) => {
        const hasPermission = getPermissionInfo(location.pathname, btn.label, loggedinuser);
        return (
            <Button
                key={idx}
                disabled={!hasPermission}
                className={`w-full flex items-center rounded border px-4 py-3 text-sm border-gray-300 text-[#804c3c] bg-white hover:bg-gray-100
                    ${hasPermission ? ' cursor-pointer' : ' cursor-not-allowed'}`}
                onClick={() => { navigate(`/reports/${btn.path}`); }}
            >
                <span className={`${hasPermission ? 'flex-1 text-[#804c3c]' : 'flex-1 text-black'} flex items-center`}>
                    {btn.label}
                    {btn.isNew && <NewBadge />}
                </span>
                <span className="ml-auto">
                    <Icon name="arrow-right" size={1.4} className={hasPermission ? 'text-[#804c3c]' : 'text-black'} />
                </span>
            </Button>
        );
    };

    return (
        <Layout>
            <Header title="Report" />
            <div className="p-4">
                <h2 className="text-lg font-semibold mb-3">Asset Report</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
                    {reportButtons.map(renderButton)}
                </div>

                <h2 className="text-lg font-semibold mb-3">Inventory Report</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
                    {InventoryReportButtons.map(renderButton)}
                </div>

                <h2 className="text-lg font-semibold mb-3">Task Reports</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {taskReportButtons.map(renderButton)}
                </div>
            </div>
        </Layout>
    );
};

export default Reports;
